import { getReward } from './getReward';
import { getType } from './getType';
export const getCouponSubtitle = (context, subtitleParams) => {
    const type = getType(context, subtitleParams);
    const reward = getReward(context, subtitleParams);
    return `${type} ${reward}`;
};
//# sourceMappingURL=getCouponSubtitle.js.map